function initStrategicObjectiveRiskForm() {
    const form = document.getElementById("strategic-objective-risk-form");

    if (!form) return;

    if (form.dataset.strategicObjectiveRiskBound === "true") return;
    form.dataset.strategicObjectiveRiskBound = "true";

    const yearInput = document.getElementById("strategic_objective_risk_year");
    const linesContainer = document.getElementById("strategic-objective-risk-lines");
    const addLineButton = document.getElementById("add-strategic-objective-risk-line");
    const lineTemplate = document.getElementById("strategic-objective-risk-line-template");

    if (!yearInput || !linesContainer || !addLineButton || !lineTemplate) return;

    let objectiveRecords = [];

    function resetSelect(select, placeholder) {
        select.innerHTML = "";

        const option = document.createElement("option");
        option.value = "";
        option.textContent = placeholder;

        select.appendChild(option);
    }

    function readObjectiveRecords(select) {
        if (!select) return [];

        return Array.from(select.options)
            .filter(function (option) {
                return option.value !== "";
            })
            .map(function (option) {
                return {
                    id: option.value,
                    text: option.textContent
                };
            });
    }

    function fillObjectiveSelect(select, records, selectedValue) {
        resetSelect(select, "Seleccione");

        records.forEach(function (record) {
            const option = document.createElement("option");
            option.value = record.id;
            option.textContent = record.text;

            if (selectedValue && selectedValue.toString() === record.id.toString()) {
                option.selected = true;
            }

            select.appendChild(option);
        });
    }

    function refreshObjectiveSelects(records) {
        document.querySelectorAll(".strategic-objective-risk-objective").forEach(function (select) {
            const currentValue = select.value;
            fillObjectiveSelect(select, records, currentValue);
        });
    }

    function loadObjectives() {
        const year = yearInput.value;

        if (!year) {
            objectiveRecords = [];
            refreshObjectiveSelects(objectiveRecords);
            return;
        }

        fetch(`/strategic_objective_risks/objectives_by_year?year=${year}`)
            .then(function (response) {
                if (!response.ok) throw new Error("Error cargando objetivos estratégicos");
                return response.json();
            })
            .then(function (data) {
                objectiveRecords = data;
                refreshObjectiveSelects(objectiveRecords);
            })
            .catch(function (error) {
                console.error(error);
            });
    }

    function riskEvaluation(probability, impact) {
        const key = `${probability}-${impact}`;

        const values = {
            "3-5": "Zona de Riesgo Moderado",
            "2-5": "Zona de Riesgo Tolerable",
            "1-5": "Zona de Riesgo Aceptable",
            "3-10": "Zona de Riesgo Importante",
            "2-10": "Zona de Riesgo Moderado",
            "1-10": "Zona de Riesgo Tolerable",
            "3-20": "Zona de Riesgo Inaceptable",
            "2-20": "Zona de Riesgo Importante",
            "1-20": "Zona de Riesgo Tolerable"
        };

        return values[key] || "";
    }

    function responseMeasures(probability, impact) {
        const key = `${probability}-${impact}`;

        const values = {
            "3-5": "Prevenir el riesgo.",
            "2-5": "Aceptar el riesgo. Prevenir el riesgo.",
            "1-5": "Aceptar el riesgo.",
            "3-10": "Prevenir el riesgo. Proteger la Institución. Compartir.",
            "2-10": "Prevenir el riesgo. Proteger la Institución. Compartir.",
            "1-10": "Proteger la Institución. Compartir.",
            "3-20": "Evitar el riesgo. Prevenir el riesgo. Proteger la Institución. Compartir.",
            "2-20": "Prevenir el riesgo. Proteger la Institución. Compartir.",
            "1-20": "Proteger la Institución. Compartir."
        };

        return values[key] || "";
    }

    function calculateLine(row) {
        const probabilitySelect = row.querySelector(".strategic-objective-risk-probability");
        const impactSelect = row.querySelector(".strategic-objective-risk-impact");
        const qualificationInput = row.querySelector(".strategic-objective-risk-qualification");
        const evaluationInput = row.querySelector(".strategic-objective-risk-evaluation");
        const responseInput = row.querySelector(".strategic-objective-risk-response-measures");

        if (!probabilitySelect || !impactSelect || !qualificationInput || !evaluationInput || !responseInput) return;

        const probability = parseInt(probabilitySelect.value, 10);
        const impact = parseInt(impactSelect.value, 10);

        if (!probability || !impact) {
            qualificationInput.value = "";
            evaluationInput.value = "";
            responseInput.value = "";
            return;
        }

        qualificationInput.value = probability * impact;
        evaluationInput.value = riskEvaluation(probability, impact);
        responseInput.value = responseMeasures(probability, impact);
    }

    function bindLineEvents(row) {
        row.querySelectorAll(".strategic-objective-risk-probability, .strategic-objective-risk-impact").forEach(function (select) {
            select.addEventListener("change", function () {
                calculateLine(row);
            });
        });

        const removeButton = row.querySelector(".remove-strategic-objective-risk-line");

        if (removeButton) {
            removeButton.addEventListener("click", function () {
                const deletedInput = row.querySelector(".strategic-objective-risk-line-deleted");
                const idInput = row.querySelector('input[name*="[id]"]');

                if (idInput && idInput.value) {
                    deletedInput.value = "1";
                    row.style.display = "none";
                } else {
                    row.remove();
                }
            });
        }
    }

    function bindAllLines() {
        document.querySelectorAll(".strategic-objective-risk-line").forEach(function (row) {
            if (row.dataset.bound === "true") return;

            bindLineEvents(row);
            calculateLine(row);

            row.dataset.bound = "true";
        });
    }

    function addLine() {
        const newId = new Date().getTime();
        const html = lineTemplate.innerHTML.replace(/NEW_RECORD/g, newId);

        linesContainer.insertAdjacentHTML("beforeend", html);

        const row = linesContainer.lastElementChild;
        const objectiveSelect = row.querySelector(".strategic-objective-risk-objective");

        if (objectiveSelect && objectiveRecords.length > 0) {
            fillObjectiveSelect(objectiveSelect, objectiveRecords, null);
        }

        bindLineEvents(row);
        calculateLine(row);
        row.dataset.bound = "true";
    }

    const firstObjectiveSelect = document.querySelector(".strategic-objective-risk-objective");
    objectiveRecords = readObjectiveRecords(firstObjectiveSelect);

    yearInput.addEventListener("change", loadObjectives);
    addLineButton.addEventListener("click", addLine);

    bindAllLines();
}

document.addEventListener("DOMContentLoaded", initStrategicObjectiveRiskForm);
document.addEventListener("turbolinks:load", initStrategicObjectiveRiskForm);
